/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'route': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<defs/><path pid="0" id="route" class="cls-1" d="M42.273 290h-10v-1.8h8.182v-3.6h1.818v5.4zm-.909-7.415c-.628-.9-3.636-5.053-3.636-6.985a3.637 3.637 0 0 1 7.273 0c-.001 1.834-2.686 5.62-3.637 6.985zm0-8.785a1.811 1.811 0 0 0-1.818 1.8 11.96 11.96 0 0 0 1.818 3.761 11.959 11.959 0 0 0 1.818-3.761 1.811 1.811 0 0 0-1.818-1.8zm-12.728 15.985c-.628-.9-3.636-5.053-3.636-6.985a3.637 3.637 0 0 1 7.273 0c0 1.834-2.685 5.62-3.637 6.985zm0-8.785a1.811 1.811 0 0 0-1.818 1.8 11.96 11.96 0 0 0 1.818 3.761 11.96 11.96 0 0 0 1.818-3.761 1.811 1.811 0 0 0-1.818-1.8z" transform="translate(-25 -272)"/>'
  }
})
